var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_888_3787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68075 10.1082C10.3933 10.1082 12.5922 7.8454 12.5922 5.0541C12.5922 2.2628 10.3933 0 7.68075 0C4.96823 0 2.76929 2.2628 2.76929 5.0541C2.76929 7.8454 4.96823 10.1082 7.68075 10.1082Z",
    fill: "#434C58",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3961 17.3786C15.3903 17.7251 15.1174 18 14.7807 18H0.621069C0.284349 18 0.00568416 17.7251 -0.000121351 17.3786C-0.0175379 16.3571 0.156627 14.3677 1.63703 12.7009C2.96069 11.2134 4.58624 10.8191 5.17259 10.7056C5.53253 10.8549 5.97375 11.0162 6.49044 11.1297C6.93747 11.2253 7.34966 11.2731 7.69799 11.291C8.05213 11.2731 8.45851 11.2253 8.91134 11.1297C9.42803 11.0162 9.86925 10.8549 10.2292 10.7056C10.8039 10.8191 12.383 11.2014 13.6893 12.6233C13.7183 12.6472 13.7415 12.671 13.7648 12.7009C15.2394 14.3677 15.4193 16.3571 15.3961 17.3786Z",
    fill: "#434C58",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5616 11.4165C19.8221 11.4165 21.6545 9.53088 21.6545 7.20479C21.6545 4.87871 19.8221 2.99304 17.5616 2.99304C15.3012 2.99304 13.4688 4.87871 13.4688 7.20479C13.4688 9.53088 15.3012 11.4165 17.5616 11.4165Z",
    fill: "#434C58",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17.4802C23.9942 17.773 23.7678 18 23.4833 18H16.1045C16.1858 17.8148 16.2322 17.6117 16.238 17.3966C16.2612 16.2496 16.0581 14.069 14.4731 12.2111C14.9028 12.0378 15.2685 11.9602 15.4717 11.9183C15.7678 12.0438 16.1393 12.1752 16.5689 12.2648C16.9463 12.3485 17.2888 12.3903 17.5791 12.4022C17.8752 12.3903 18.2119 12.3485 18.5893 12.2648C19.0189 12.1752 19.3904 12.0438 19.6865 11.9183C20.1742 12.0079 21.5327 12.3365 22.6357 13.5791C23.8723 14.9711 24.0174 16.6319 24 17.4802Z",
    fill: "#434C58",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_888_3787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/users.6f0a9cfc08445aab4548b27e384654d5.svg";